module.exports = __webpack_public_path__ + "img/istockphoto-1287121458-170667a.d8bbf4ba.jpg";